import { alertController } from "@ionic/vue";

export const showAlert = async (header='¡Atención!',message:string) => {

    const alert = await alertController.create({
        header: header,
        message: message,        
        buttons: [
            {
                text: 'OK',
                role: 'confirm',
                cssClass: 'custom-alert-button',
                handler: () => {
                  console.log('Alert confirmed');
                },
            }
        ],
    });

    await alert.present();
}